export type Step = { key: string; id: number; kind: 'source' | 'task' | 'audio'; label: string; type: string; status: string; parent: string | null; url: string; language?: string; tag?: string; has_audio?: boolean; payment_url?: string };
export type Project = { id: number; name: string; labels: string[]; created_at: string; updated_at: string; status: string; steps: Step[]; state?: Record<string, any> };
export const statusLabel: Record<string, string> = { awaiting_payment: 'Awaiting payment', complete: 'Complete', working: 'In progress', ready: 'Ready to continue', needs_attention: 'Needs attention' };
export function workflowPaths(steps: Step[]): Step[][] {
  const parents = new Set(steps.map(s => s.parent));
  const byKey = new Map(steps.map(s => [s.key, s]));
  return steps.filter(s => !parents.has(s.key)).map(leaf => {
    const path: Step[] = []; const seen = new Set<string>(); let node: Step | undefined = leaf;
    while (node && !seen.has(node.key)) { path.unshift(node); seen.add(node.key); node = node.parent ? byKey.get(node.parent) : undefined; }
    return path;
  });
}
